import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import { ModalDialog, useMount } from "@sportal/cdk";
import { DeviceDialogInput } from "../deviceForm";
import {
  CommonModalFooter,
  CommonModalHeader,
  useForm,
} from "../../../../../components";
import { useDeviceNameValidator, isStringDifferent } from "../deviceForm";

export function RenameDeviceDialog({ modal, devices, device }) {
  const form = useForm(
    {
      name: device.name,
      onLoad: true,
    },
    { name: isStringDifferent }
  );
  const setError = (name, error) => {
    if (!_.isEmpty(error)) {
      form.setError(`${name}`, error);
    } else {
      form.setError(`${name}`, null);
    }
  };

  useMount(() => {
    const nameError = validateName(_.trim(device.name));

    setError("name", nameError);
  });

  const otherDevices = _.reject(devices, { name: device.name });
  const validateName = useDeviceNameValidator(otherDevices);

  const changeName = (name) => {
    const nameError = validateName(_.trim(name));

    form.set("name", name);
    setError("name", nameError);
  };

  const submit = () => modal.resolve({ name: _.trim(form.values.name) });
  const close = () => modal.reject();

  return (
    <ModalDialog
      submitHandler={submit}
      rejectHandler={close}
      disabled={!form.didFormChange() || form.hasErrors()}
    >
      <CommonModalHeader>
        <FormattedMessage id="rename_device" />
      </CommonModalHeader>
      <ModalDialog.Body>
        <DeviceDialogInput
          label="device_name"
          placeholder="enter_device_name"
          value={form.values.name}
          onChange={changeName}
          error={form.errors.name}
          autoFocus
          maxLength="30"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck="false"
        />
      </ModalDialog.Body>
      <CommonModalFooter />
    </ModalDialog>
  );
}
